// Add here the action types for react-redux-form

export const FORM_CHANGE = 'rrf/change'
